<template>
  <div>
    {{ $t(value.key) }}
    <div
      v-for="entry in changeEntries"
      :key="entry.className"
      :class="entry.className">
      <template v-if="value.key === 'AdditionalContactPersonsAdded'">
        <ContactPerson
          v-for="(contact, index) in entry.value"
          :key="index"
          :item="contact"/>
      </template>
      <template v-else>
        {{ entry.value }}
      </template>
    </div>
  </div>
</template>
<script>
import ContactPerson from 'components/tenders/ContactPerson.vue'

export default {
  name: 'EventHistoryTenderChangeProps',
  computed: {
    changeEntries() {
      return [
        { value: this.formatChangeValue(this.value?.valueOld), className: 'event-history-change-prop_old' },
        { value: this.formatChangeValue(this.value?.valueNew), className: 'event-history-change-prop_new' },
      ].filter(entry => entry.value)
    },
  },
  methods: {
    formatChangeValue(rawValue) {
      if (!rawValue) {
        return null
      }
      if (this.value.key === 'AuctionPeriodTo') {
        const date = new Date(rawValue)
        return `${this.$d(date, 'shortDate')} ${this.$d(date, 'longTime')}`
      }
      return rawValue
    },
  },
  props: {
    value: {
      type: Object
    }
  },
  components: {
    ContactPerson
  },
  i18n: {
    messages: {
      uk: {
        AuctionPeriodTo: 'Завершення періоду аукціону',
        AdditionalContactPersonsAdded: 'Додано додаткових контактних осіб',
      },
      en: {
        AuctionPeriodTo: 'End of auction period',
        AdditionalContactPersonsAdded: 'Additional contact persons added',
      },
    }
  }
}
</script>
<style scoped lang="scss">
.event-history-change-prop {
  list-style-type: decimal;
  background: #b0dbd8;
  border-radius: 0 25px 25px;
  transition: all 0.25s;
  padding-left: 100%;
  &_old {
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 14px;
  }
  &_new {
    font-size: 14px;
  }
}
</style>
